import React from "react";
import HomeRedesignLayout from "../../components/home/rpg/HomeRedesignLayout";
import HomeRpgHero from "../../components/home/rpg/HomeRpgHero";
import HomeRpgAvailability from "../../components/home/rpg/HomeRpgAvailability";
import HomeRpgFeatureCards from "../../components/home/rpg/HomeRpgFeatureCards";
import HomeRpgOsharSection from "../../components/home/rpg/HomeRpgOsharSection";
import HomeRpgJourneyRoadmap from "../../components/home/rpg/HomeRpgJourneyRoadmap";
import HomeRpgEcosystemBanner from "../../components/home/rpg/HomeRpgEcosystemBanner";
import HomeRpgFinalCta from "../../components/home/rpg/HomeRpgFinalCta";
import Sales from "../../components/Sales/Sales";
import { HOME_PAGE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";

const Home = () => {
  usePageSeo(HOME_PAGE_SEO);

  return (
    <HomeRedesignLayout>
      <main>
        <HomeRpgHero />
        <HomeRpgAvailability />
        <HomeRpgFeatureCards />
        <HomeRpgOsharSection />

        <div className="td-rpg-embed td-rpg-embed--sales">
          <Sales />
        </div>

        <HomeRpgJourneyRoadmap />

        <HomeRpgEcosystemBanner />

        <HomeRpgFinalCta />
      </main>
    </HomeRedesignLayout>
  );
};

export default Home;
